import { render } from "./PermissionAlert.vue?vue&type=template&id=3f93851f&scoped=true"
import script from "./PermissionAlert.vue?vue&type=script&lang=js"
export * from "./PermissionAlert.vue?vue&type=script&lang=js"

import "./PermissionAlert.vue?vue&type=style&index=0&id=3f93851f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f93851f"]])

export default __exports__